import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=e40a8c80&scoped=true&"
import script from "./FaqSection.vue?vue&type=script&lang=js&"
export * from "./FaqSection.vue?vue&type=script&lang=js&"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=e40a8c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40a8c80",
  null
  
)

export default component.exports